<script setup>
import { toRefs, computed } from "vue";
import { useRouter } from "vue-router";
import { formatDateTimeJaWithWeekday } from "@/utils/date.js";

const props = defineProps({
  liveData: Array,
});

const { liveData } = toRefs(props);
const router = useRouter();
// orderフィールドでソートするヘルパー関数
const sortByOrder = (a, b) => {
  // orderフィールドを数値に変換（null/undefined/空文字の場合は9999）
  const orderA =
    a.order !== undefined && a.order !== null && a.order !== "" ? Number(a.order) : 9999;
  const orderB =
    b.order !== undefined && b.order !== null && b.order !== "" ? Number(b.order) : 9999;

  // NaNの場合は9999として扱う
  const numA = isNaN(orderA) ? 9999 : orderA;
  const numB = isNaN(orderB) ? 9999 : orderB;

  return numA - numB;
};

const liveproductsData = computed(() => {
  return liveData.value
    .filter(function (liveData) {
      return liveData.live_status === "live";
    })
    .sort(sortByOrder);
});

const liveproductsDatainprogress = computed(() => {
  return liveData.value
    .filter(function (liveData) {
      return liveData.live_status === "inprogress";
    })
    .sort(sortByOrder);
});

// const router = useRouter();

const toItemlist = (productsData) => {
  // 配信クラファンの場合
  if (productsData.isCrowdfunding && productsData.projectid) {
    router.push(`/crowdfunding/${productsData.projectid}`);
  } else {
    router.push(`/itemlist_v/${productsData.event_id}`);
  }
  // this.$router.push(`/itemlist?vtubername=${card.vtuber_en}`, () => {});
};
const toMain = (productsData) => {
  // 配信クラファンの場合
  if (productsData.isCrowdfunding && productsData.projectid) {
    // 配信中の場合、直接liveページへ遷移
    if (productsData.live_status === "live") {
      router.push(`/crowdfunding/${productsData.projectid}/live`);
    } else {
      router.push(`/crowdfunding/${productsData.projectid}`);
    }
  } else {
    router.push(`main?event_id=${productsData.event_id}`);
  }
  // this.$router.push(`/itemlist?vtubername=${card.vtuber_en}`, () => {});
};

// タイトルを取得
const getTitle = (item) => {
  return item.eventtitle || item.projectTitle || "";
};

// サブタイトルを取得
const getSubtitle = (item) => {
  return item.livenumber || item.vendor_ja || "";
};

// ラベルテキストを取得
const getLabelText = (item) => {
  return item.isCrowdfunding || item.projectid ? "配信クラファン" : "リアルタイムくじ引き";
};

// ラベルの背景色を取得
const getLabelColor = (item) => {
  return item.isCrowdfunding || item.projectid ? "#DA3990" : "#9c27b0";
};
</script>
<template>
  <div>
    <!-- Live products section -->
    <v-row class="pc-ma-2 cancelrow" justify="center">
      <v-col
        v-for="(productsData, index) in liveproductsData"
        :key="index"
        cols="12"
        sm="6"
        md="4"
        class="cancelpadding"
      >
        <!-- Image with label -->
        <div class="image-container">
          <v-img
            class="clickable-area"
            :src="productsData.vendor_image"
            @click="toMain(productsData)"
          />
          <div class="realtime-label" :style="{ backgroundColor: getLabelColor(productsData) }">
            {{ getLabelText(productsData) }}
          </div>
        </div>

        <!-- Card content -->
        <v-card class="custom-card">
          <div class="livecontainer clickable-area pa-2" @click="toMain(productsData)">
            <div class="livestatus mb-2">
              <p>配信中</p>
            </div>
            <h3 class="title mb-2">{{ getTitle(productsData) }}</h3>
            <p class="title mb-2">{{ getSubtitle(productsData) }}</p>
            <p class="time mb-2">
              <v-icon size="20">mdi-timer</v-icon>
              {{ formatDateTimeJaWithWeekday(productsData.livedate.end.toDate()) }}まで
            </p>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Live products in progress section -->
    <v-row class="pc-ma-2" justify="center">
      <v-col
        v-for="(productsData, index) in liveproductsDatainprogress"
        :key="index"
        cols="12"
        sm="6"
        md="4"
        class="cancelpadding"
      >
        <!-- Image with label -->
        <div class="image-container">
          <v-img
            class="cursor mb-2 clickable-area"
            :src="productsData.vendor_image"
            @click="toItemlist(productsData)"
          />
          <div class="realtime-label" :style="{ backgroundColor: getLabelColor(productsData) }">
            {{ getLabelText(productsData) }}
          </div>
        </div>

        <!-- Card content -->
        <v-card class="custom-card" color="white">
          <div class="livecontainer pa-2 clickable-area" @click="toItemlist(productsData)">
            <div class="livestatusinprogress mb-2">
              <p>配信予定</p>
            </div>
            <h3 class="title mb-2">{{ getTitle(productsData) }}</h3>
            <p class="title mb-2">{{ getSubtitle(productsData) }}</p>
            <p class="time mb-2">
              <v-icon size="20">mdi-timer</v-icon>
              {{ formatDateTimeJaWithWeekday(productsData.livedate.start.toDate()) }}から
            </p>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
.maincontainer {
  margin: 10px 0 15px 0;
}

.livecontainer {
  border: solid 1px #454545;
  background-color: rgb(255, 254, 245);
}
.livestatus {
  border: solid 1px rgb(240, 172, 196);
  float: left;
  margin: 15px 0 5px 20px;
  background-color: rgb(240, 172, 196);
  color: white;
  padding: 5px 5px 5px 5px;
  font-size: 12px;
}
.title {
  clear: both;
  margin: 5px 0 5px 20px;
  text-align: left;
  line-height: 1.3;
}
.time {
  margin: 5px 0 15px 20px;
  text-align: left;
}
.livestatusinprogress {
  border: solid 1px rgb(152, 45, 166);
  float: left;
  margin: 15px 0 5px 20px;
  background-color: rgb(152, 45, 166);
  color: white;
  padding: 5px 5px 5px 5px;
  font-size: 12px;
}
.clickable-area {
  cursor: pointer;
}
.cancelrow {
  margin: 0px;
}
.cancelpadding {
  padding: 5px;
}

.image-container {
  position: relative;
  display: inline-block;
  width: 100%;
}

.realtime-label {
  position: absolute;
  top: 0;
  right: 0;
  color: white;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 500;
  z-index: 10;
  border-radius: 0 0 0 4px; /* 左下のみ角丸 */
}

@media (min-width: 960px) {
  .pc-ma-2 {
    margin: 16px !important;
  }
}
</style>
